import type { FC } from 'react';
import { CategoryField } from './CategoryField';
import { useFieldContext } from './contexts';
import { Field } from './Field';

interface Props {
  readonly isDisabled?: boolean;
  readonly isLoading?: boolean;
  readonly label?: string;
}

export const CategoriesField: FC<Props> = ({ isDisabled, label, isLoading }) => {
  const field = useFieldContext<CategoryField[]>();
  return (
    <Field label={label ?? 'Categories'} name={field.name} isNormal={false}>
      <div className={`control ${isLoading ? 'is-loading' : ''}`}>
        <div className={'checkboxes'} id={field.name}>
          {field.state.value.map((c, idx) => (
            <label className={`checkbox ${isLoading ? 'is-skeleton' : ''}`} aria-disabled={isDisabled} key={idx}>
              <input
                checked={c.isChecked}
                disabled={isDisabled}
                type={'checkbox'}
                onChange={(e) => {
                  const copy = [...field.state.value];
                  if (copy[idx]) {
                    copy[idx] = {
                      ...copy[idx],
                      isChecked: e.target.checked,
                    };
                    field.handleChange(copy);
                  }
                }}
                onBlur={field.handleBlur}
              />
              {c.description}
            </label>
          ))}
        </div>
        {field.state.meta.errors.length ? (
          <p className={'help is-danger'}>{field.state.meta.errors.join(', ')}</p>
        ) : null}
      </div>
    </Field>
  );
};
